<div uiactionstrip>
  <label [label]="'View'" [labelCssClass]="'text-input-label'"></label>
  <dropdown
    #viewDropdownRef
    [initialValue]="$safeNavigationMigration(selectedView()?.name)"
    [settings]="{
      placeholder: 'Select',
      placeholderPersists: true,
      options: popupContent(),
      optionGroup: 'group',
      optionsFiltering: false,
      optionsSorting: false,
      showClearButton: false,
      stateless: true,
      tag: 'Views Dropdown',
    }"
    [optionCssClass]="'hover:[&>icon]:block'"
    [UiOptionTemplateRef]="popupItemTmpl"
    (OptionIsSelected)="selectView($event)"
  >
    <btn
      #moreTriggerRef
      uitool
      class="unstyled xxs pinned"
      [settings]="{
        iconSize: 'icon-size-[1rem]',
        icon: ICONS.MORE_VERT,
        iconOnly: true,
        tag: 'Views Dropdown More Actions',
      }"
      (click)="
        viewDropdown()?.uiPopupDir()?.hidePopup();
        morePopup()?.togglePopup(moreTriggerRef.hostElRef.nativeElement);
        $event.stopImmediatePropagation()
      "
    >
      <ul #morePopupRef class="right fit" [UiPopup]="{}">
        <li
          uipopupoption
          [attr.uipopupoptiondisabled]="
            !selectedView() || !selectedView()!.canEdit ? '' : undefined
          "
          (click)="showSaveView('edit')"
        >
          <icon [iconDefinition]="ICONS.EDIT"></icon>
          Edit Name
        </li>
        <li uipopupoption (click)="showSaveView('save')">
          <icon [iconDefinition]="ICONS.SAVE"></icon>
          Save As
        </li>
        <li
          uipopupoption
          [attr.uipopupoptiondisabled]="
            !selectedView() || !selectedView()!.canEdit ? '' : undefined
          "
          (click)="showDeleteView()"
        >
          <icon [iconDefinition]="ICONS.DELETE"></icon>
          Delete
        </li>
        @if (hasMultipleGroups()) {
          <li
            uipopupoption
            [attr.uipopupoptiondisabled]="
              !selectedView() || !selectedView()!.canEdit ? '' : undefined
            "
            (click)="onSetGroupDefault.emit()"
          >
            <icon [iconDefinition]="ICONS.STAR"></icon>
            Set Group Default
          </li>
        }
      </ul>
    </btn>
  </dropdown>
  <ng-template #popupItemTmpl let-option>
    @let viewEntityOption = toViewEntityOption(option);

    <span
      class="pointer-events-none"
      [innerHTML]="`${viewEntityOption.view.name}${viewEntityOption.view.isDefault ? '<sup>*</sup>' : ''}`"
    ></span>
    <icon
      class="ml-auto"
      [class.hidden]="!viewEntityOption.view.isFavorite"
      [iconDefinition]="ICONS.STAR"
      [iconSize]="'icon-size-[1rem]'"
      [iconColor]="
        viewEntityOption.view.isFavorite
          ? 'text-orange-300'
          : 'text-input-default-icon'
      "
      (click)="
        onSetFavoriteView.emit(viewEntityOption.view);
        $event.stopImmediatePropagation()
      "
    ></icon>
  </ng-template>
  @if (withClearFilters() && canClearFilters()) {
    <btn
      class="tertiary"
      (click)="onClearFilters.emit()"
      title="Clear current state"
      [settings]="{
        label: 'Clear',
        disabled: isClearDisabled(),
        tag: 'Clear Filters Button',
      }"
    >
    </btn>
  }

  <btn
    class="primary"
    (click)="saveView()"
    title="Save or update current state"
    [settings]="{
      label: 'Save',
      disabled: isSaveDisabled(),
      tag: 'Save View Button',
    }"
  >
  </btn>
</div>

<modal
  #uiSaveViewModal
  [settings]="{
    hasBackdrop: true,
    label: saveMode() === 'save' ? 'Save View As' : 'Edit Name',
  }"
  (onModalClose)="modalIsVisible.set(false)"
>
  <text
    [(value)]="viewName"
    [settings]="{
      label: 'View Name:',
      labelPosition: 'embedded',
      placeholder: 'Enter view name',
      placeholderPersists: true,
      stateless: true,
      tag: 'View Name Input',
    }"
  >
  </text>
  @if (showRadioGroup()) {
    <radio-group
      class="views-radio"
      [(value)]="radioCheck"
      [settings]="{
        options: viewGroupsOptions(),
        stateless: true,
        tag: 'View Group Radio Group',
      }"
    ></radio-group>
  }

  <div uimodalfooter>
    <btn
      class="primary"
      [settings]="{
        label: 'Save',
        tag: 'Save View Modal Save Button',
      }"
      (click)="onSave()"
    >
    </btn>
  </div>
</modal>
